import { useState, useEffect } from 'react';
import classnames from 'classnames';

import {
  Italic as ItalicIcon,
  Underline as UnderlineIcon,
  Bold as BoldIcon,
  Strikethrough as StrikethroughIcon,
} from 'lucide-react';
import * as EditorTypeAll from '../tinymce.d';

interface Props {
  editorInstance: EditorTypeAll.Editor;
}

const Bold = ({ editorInstance }: Props) => {
  const [isBold, setIsBold] = useState(false);

  useEffect(() => {
    if (editorInstance) {
      editorInstance.on('NodeChange', () => {
        setIsBold(editorInstance.queryCommandState('Bold'));
      });
    }
  }, [editorInstance]);

  const boldAction = () => {
    document.body.click();
    editorInstance.execCommand('Bold');
  };

  return (
    <>
      <div
        className={classnames([
          'inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]',
          isBold && 'bg-[#E5E5E5] hover:bg-[#E5E5E5]',
        ])}
        onClick={boldAction}
      >
        <BoldIcon strokeWidth={1.5} size={18} />
      </div>
    </>
  );
};

export const Italic = ({ editorInstance }: Props) => {
  const [isItalic, setIsItalic] = useState(false);

  useEffect(() => {
    if (editorInstance) {
      editorInstance.on('NodeChange', () => {
        setIsItalic(editorInstance.queryCommandState('Italic'));
      });
    }
  }, [editorInstance]);

  const italicAction = () => {
    document.body.click();
    editorInstance.execCommand('Italic');
  };

  return (
    <>
      <div
        className={classnames([
          'inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]',
          isItalic && 'bg-[#E5E5E5] hover:bg-[#E5E5E5]',
        ])}
        onClick={italicAction}
      >
        <ItalicIcon strokeWidth={1.5} size={18} />
      </div>
    </>
  );
};

export const Underline = ({ editorInstance }: Props) => {
  const [isUnderline, setIsUnderline] = useState(false);

  useEffect(() => {
    if (editorInstance) {
      editorInstance.on('NodeChange', () => {
        setIsUnderline(editorInstance.queryCommandState('Underline'));
      });
    }
  }, [editorInstance]);

  const underlineAction = () => {
    document.body.click();
    editorInstance.execCommand('Underline');
  };

  return (
    <>
      <div
        className={classnames([
          'inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]',
          isUnderline && 'bg-[#E5E5E5] hover:bg-[#E5E5E5]',
        ])}
        onClick={underlineAction}
      >
        <UnderlineIcon strokeWidth={1.5} size={18} />
      </div>
    </>
  );
};

export const Strikethrough = ({ editorInstance }: Props) => {
  const [isStrikethrough, setIsStrikethrough] = useState(false);

  useEffect(() => {
    if (editorInstance) {
      editorInstance.on('NodeChange', () => {
        setIsStrikethrough(editorInstance.queryCommandState('Strikethrough'));
      });
    }
  }, [editorInstance]);

  const strikethroughAction = () => {
    document.body.click();
    editorInstance.execCommand('Strikethrough');
  };

  return (
    <>
      <div
        className={classnames([
          'inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]',
          isStrikethrough && 'bg-[#E5E5E5] hover:bg-[#E5E5E5]',
        ])}
        onClick={strikethroughAction}
      >
        <StrikethroughIcon strokeWidth={1.5} size={18} />
      </div>
    </>
  );
};

export default Bold;
